export default __webpack_public_path__ + "images/ceebe4da0ffc32b8626807bb71acf708-chatIcon.svg";